export const ADD_TEXT = 'ADD_TEXT';